import styled from "styled-components";

import useFilters from "./filters/useFilters";
import useProductSearch from "../../../../../clients/productSearch/useProductSearch";

export default function Counter() {
    const [filters] = useFilters();

    const products = useProductSearch(filters);

    if (!products.data) return undefined;

    return (
        <Styled>
            <div>
                <span>{ products.data.searchProducts.results.totalCount }</span>
                <span>Products</span>
            </div>
            <div>
                <span>{ products.data.searchProducts.enumerateBrands.length }</span>
                <span>Brands</span>
            </div>
            <div>
                <span>{ products.data.searchProducts.enumerateBimClasses.length }</span>
                <span>BIMClasses</span>
            </div>
        </Styled>
    );
}

const Styled = styled.div`
    color: #0004;
    cursor: default;
    display: flex;
    flex-direction: row;
    font-size: .8rem;
    gap: 16px;

    div {
        display: flex;
        gap: 4px;

        &:first-child {
            padding-left: 8px;
        }

        span:last-child {
            font-weight: lighter;
        }
    }
`;
